import CustomSection from "components/CustomSection";
import { Container, Box } from "@mui/system";
import { Typography } from "@mui/material";
import styles from "./styles.module.css";
// import arrow_white from "assets/static/arrow_white.png";

import services1 from "assets/static/landing/ai.svg";
import services2 from "assets/static/landing/dev.svg";
import services3 from "assets/static/landing/analytics.svg";
import { Parallax } from "react-scroll-parallax";
import ScrollTransition from "components/ScrollTransition";
import analytics from "assets/static/landing/SERVIÇO 2 - 275 × 257.png";
import team from "assets/static/landing/SERVIÇO 3 - 275 × 259.png";
import ai from "assets/static/landing/SERVIÇO 1 - 275 × 256.png";

const Servicos = ({ landing_data, dark_mode }) => {
  return (
    <CustomSection
      bg_color="var(--background-0)"
      style={{
        overflow: "hidden",
        minHeight: "auto",
        padding: "8rem 0",
      }}
      id="servicos"
    >
      <Container
        maxWidth="xl"
        sx={{
          width: "100vw",
        }}
      >
        <ScrollTransition>
          <Typography
            variant="h2"
            component="h2"
            sx={{
              textAlign: "center",
              fontWeight: "bold",
              marginBottom: "1.4rem",
            }}
          >
            Nossos Serviços
          </Typography>
        </ScrollTransition>

        <ScrollTransition>
          <Typography
            variant="p"
            component="p"
            sx={{
              textAlign: "center",
              margin: "0 auto",
              marginBottom: "4rem",
              fontWeight: "normal",
              fontSize: "1.1rem",
              maxWidth: "30rem",
              "&:after": {
                content: "''",
                display: "block",
                marginTop: "30px",
                width: "40px",
                borderTop: "2px solid #444",
                margin: "30px auto 0",
              },
            }}
          >
            Algumas das nossas especialidades
          </Typography>
        </ScrollTransition>

        <ScrollTransition>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8rem 1rem",
              paddingTop: "4rem",
            }}
          >
            <ServiceCard
              title={'Conexão inteligente entre compradores e fornecedores'}
              description={'O iGooB conecta quem precisa de materiais de construção a quem vende, reunindo diversas lojas e profissionais em um só aplicativo.'}
              image={ai}
              glowColor={landing_data[0].glowColor}
              speed={15}
              dark_mode={dark_mode}
            />
            <ServiceCard
              title={'Compra prática e segura'}
              description={'Com poucos cliques, o usuário encontra produtos, compara preços e realiza pedidos de forma simples, rápida e confiável.'}
              image={analytics}
              glowColor={landing_data[0].glowColor}
              speed={30}
              dark_mode={dark_mode}
            />
            <ServiceCard
              title={'Soluções completas para quem constrói'}
              description={'Do cimento ao acabamento — o iGooB oferece tudo o que uma obra precisa, além de itens para o dia a dia, como chuveiros, torneiras, lâmpadas e mobília.'}
              image={team}
              glowColor={landing_data[0].glowColor}
              speed={45}
              dark_mode={dark_mode}
            />
          </div>
        </ScrollTransition>
      </Container>
    </CustomSection>
  );
};

const ServiceCard = ({ title, description, image, glowColor, speed, dark_mode }) => {
  return (
    <Box
      sx={{
        width: "26rem",
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        padding: "0rem 2rem",
        borderRadius: "0.8rem",
        position: "relative",
        transition: "all 0.3s",
        cursor: "pointer",
        gap: "1rem",
        "&:hover": {
          // backgroundColor: "var(--background-0)",
          transform: "translateY(-1rem)",
        },
        // "&:hover img": {
        //   WebkitFilter: `drop-shadow(0px 0px 40px ${glowColor})`,
        //   filter: `drop-shadow(0px 0px 40px ${glowColor})`,
        // },
      }}
    >
      <Box
        component="img"
        className="Transition-1"
        src={image}
        alt="Ícone do cartão"
        sx={{
          height: "18rem",
          marginBottom: "1rem",
          margin: "0 auto",
          marginBottom: "2rem",
          background: !dark_mode && `radial-gradient(circle, ${glowColor} -50%, rgba(255,255,255,0) 70%)`,
          padding: "1rem",
          // WebkitFilter: `drop-shadow(0px 0px 40px ${glowColor})`,
          // filter: `drop-shadow(0px 0px 40px ${glowColor})`,
        }}
      />

      <p
        style={{
          fontSize: "1.5rem",
          fontWeight: "bold",
          textAlign: "center",
          color: "var(--text-main-2)",
          marginBottom: "1rem",
        }}
      >
        {title
          .replace("Somos especialistas em <a href='test'>", "")
          .replace("</a>", "")}
      </p>
      <p
        style={{
          fontSize: "1rem",
          color: "var(--text-main-1)",
          textAlign: "justify",
          lineHeight: "1.5rem",
        }}
      >
        {description}
      </p>

      {/* <Box
        className={`Transition-1 ${styles.Button}`}
        component="button"
        sx={{
          position: "relative",
          margin: "0 auto",
          width: "max-content",
          color: "var(--text-color0)",
          "&:after": {
            content: '""',
            position: "absolute",
            width: "100%",
            height: "2px",
            bottom: "0",
            left: "0",
            backgroundColor: "var(--text-color0)",
            transform: "scaleX(0)",
            transformOrigin: "bottom right",
            transition: "transform 0.3s",
          },
          "&:hover:after": {
            transform: "scaleX(1)",
            transformOrigin: "bottom left",
          },
        }}
      >
        Ver mais
      </Box> */}
    </Box>
  );
};

export default Servicos;
